// Register the service worker for offline / installable behaviour.
// We only register in production builds because CRA's dev server serves
// files through webpack-dev-server, which the browser blocks from caching
// as a real app-shell.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch(() => {
        // Silent — the worker is a progressive enhancement.
      });
  });
}
